/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import ClipboardJS from "clipboard";
Buyapowa.Views.ReferrerPopover = class ReferrerPopover {
    constructor(el, controller) {
        this.el = el;
        this.controller = controller;
        this.pb = new Buyapowa.Helpers.ProgressButton(
            this.el.find("button[data-submit]"),
        );
        this.shortUrlArea = this.el.find("[data-short-url]");
        this.actionButton = this.el.find("button[data-action-button]");
        this.el.find("a[href]").attr("target", "_blank");

        this._bindEvents();
    }

    setStep(step) {
        if (step === 1) {
            this.el.find("[data-step-indicator='1']").addClass("filled");
            this.el.find("[data-step-indicator='2']").removeClass("filled");
            this.el.find("[data-visible-step='1']").css("display", "");
            this.el.find("[data-visible-step='2']").css("display", "none");
            return (this.step = 1);
        } else {
            this.el.find("[data-step-indicator='1']").removeClass("filled");
            this.el.find("[data-step-indicator='2']").addClass("filled");
            this.el.find("[data-visible-step='1']").css("display", "none");
            this.el.find("[data-visible-step='2']").css("display", "");
            return (this.step = 2);
        }
    }

    statusTexts(type) {
        return this.el.data("status-texts")[type];
    }

    setInProgress(text) {
        return this.pb.started(text);
    }

    setFinished(success, text) {
        return this.pb.finished(success, text);
    }

    setShortUrl(shortUrl) {
        this.shortUrlArea.find("[data-host]").text(shortUrl.host + "/");
        this.shortUrlArea.find("[data-path]").text(shortUrl.path);
        return (this.shortUrl = shortUrl.url);
    }

    formData() {
        const data = {
            first_name: this.el.data("first-name"),
            last_name: this.el.data("last-name"),
            email: this.el.data("email"),
            custom_field_value: this.el.data("custom-field-value"),
            locale: this.el.data("locale"),
            client_data: JSON.stringify(this.el.data("client-data")),
            custom_fields: JSON.stringify(this.el.data("custom-fields")),
        };

        data[this.el.data("csrf-param")] = this.el.data("csrf-token");
        return data;
    }

    submitUrl() {
        return this.el.data("submit-url");
    }

    _nativeSharing() {
        return this.el.data("native-sharing");
    }

    _applyActionButtonPositiveFeedback() {
        this.actionButton
            .find("i")
            .addClass("icon-tick")
            .removeClass("icon-docs");
        this.actionButton.attr("disabled", "");

        const cb = () => {
            this.actionButton
                .find("i")
                .removeClass("icon-tick")
                .addClass("icon-docs");
            return this.actionButton.removeAttr("disabled");
        };

        return setTimeout(cb, 1000);
    }

    getEventMethod(eventName) {
        return window[this.el.data("event-methods")[eventName]];
    }

    _bindEvents() {
        this.el.on("click", "button[data-submit]", (e) => {
            e.preventDefault();
            this.controller.submitClicked();
            return false;
        });

        this.el.on("click", "a[href]", (e) => {
            return this.controller.linkClicked(this.step);
        });

        if (this._isMobileDevice()) {
            this.shortUrlArea.on("click", "button[data-action-button]", (e) => {
                e.preventDefault();

                navigator
                    .share({
                        title: this._nativeSharing().title,
                        text: this._nativeSharing().description,
                        url: this.shortUrl,
                    })
                    .then(() => {
                        this._applyActionButtonPositiveFeedback();
                        return this.controller.urlShared();
                    })
                    .catch((e) => {
                        if (e.name === "AbortError") {
                            this._applyActionButtonPositiveFeedback();
                            return this.controller.urlShared();
                        }
                    });

                return false;
            });

            return;
        }

        const clipboard = new ClipboardJS(this.actionButton.get(0), {
            text: () => this.shortUrl,
        });
        return clipboard.on("success", () => {
            this._applyActionButtonPositiveFeedback();
            return this.controller.urlCopied();
        });
    }

    _isMobileDevice() {
        return this._isTouchscreen() && !!navigator.share;
    }

    _isTouchscreen() {
        return window.matchMedia("(pointer: coarse)").matches;
    }
};
